import { Box, Typography } from '@mui/material';

const cardWrapper = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '584px',
  minWidth: '200px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #E4E4E4',
  boxSizing: 'border-box',
  borderRadius: '8px',
  padding: '20px',
  marginTop: '4px',
};

export const VitalDataTiles = ({ data, isBpGraph }) => {
  return (
    <Box>
      {data && (
        <Box sx={cardWrapper}>
          <Typography
            display="inline"
            variant="cardTitle"
            sx={{ color: '#4b4b4b' }}>
            {isBpGraph
              ? `${data.value.high ?? 'N.A'}/${data.value.low ?? 'N.A'}`
              : `${data.value} ${data.unit}`}
          </Typography>
          <Typography display="inline" variant="h5" sx={{ color: '#A0A4A6' }}>
            {data.date} {data.time}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
